module.exports = __webpack_public_path__ + "static/media/mov-nac-ods.0c44550b.png";